// src/pages/Contact.jsx
import React, { useState } from "react";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import SubHeader from "../components/SubHeader";

function Contact() {
  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    phoneNumber: "",
    notes: "",
  });

  const [status, setStatus] = useState(""); // for success/error message

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(""); // reset status
    try {
      const res = await fetch(
        "https://2iy42zx26k.execute-api.us-east-1.amazonaws.com/hanthanadev/user/hanthana-emailsending",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (res.status === 200) {
        setStatus("Message sent successfully!");
        setFormData({ userName: "", email: "", phoneNumber: "", notes: "" });
      } else if (res.status === 403) {
        setStatus("User doesn't exist!");
      } else {
        setStatus("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setStatus("Server error. Please try again later.");
    }
  };

  return (
    <>
      <SubHeader />
      <main>
        <section className="page-header">
          <div className="page-header__bg"></div>
          <div className="container">
            <ul className="villoz-breadcrumb list-unstyled">
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <span>Get in Touch</span>
              </li>
            </ul>
            <h2 className="page-header__title">Get in Touch</h2>
          </div>
        </section>

        <section className="contact-one" style={{ marginTop: 40 }}>
          <div className="container">
            <div className="row gutter-y-60">
              <div className="col-md-12 col-lg-5">
                <div className="contact-one__left">
                  <ul className="list-unstyled contact-one__info">
                    <li className="contact-one__info__item">
                      <div className="contact-one__info__icon">
                        <i className="icon-place"></i>
                      </div>
                      <div className="contact-one__info__content">
                        <p className="contact-one__info__text">Our Location</p>
                        <h4 className="contact-one__info__title">
                          <Link to="/contact" className="villoz-btn">
                            Contact
                          </Link>
                          No. 108, Richmond Hill Residencies, Thapodarama Road,
                          Hanthana, Kandy,
                          <br />
                          Sri Lanka 20000
                        </h4>
                      </div>
                    </li>
                    <li className="contact-one__info__item">
                      <div className="contact-one__info__icon">
                        <i className="icon-phone-call-1"></i>
                      </div>
                      <div className="contact-one__info__content">
                        <p className="contact-one__info__text">Call us at</p>
                        <h4 className="contact-one__info__title">
                          <a href="tel:+94812218625">+94 81 22 18 625</a>
                          <br />
                          <a href="tel:+94777374560">+94 777 374 560</a>
                        </h4>
                      </div>
                    </li>
                    <li className="contact-one__info__item">
                      <div className="contact-one__info__icon">
                        <i className="icon-at"></i>
                      </div>
                      <div className="contact-one__info__content">
                        <p className="contact-one__info__text">E-mail us at</p>
                        <h4 className="contact-one__info__title">
                          <a href="mailto:hanthanahouse@gmail.com">
                            hanthanahouse@gmail.com
                          </a>
                        </h4>
                      </div>
                    </li>
                  </ul>

                  <div className="contact-one__social">
                    <div className="contact-one__social__title">
                      Follow Hanthana House
                    </div>
                    <div className="contact-one__social__links">
                      <a href="https://facebook.com/hanthanahouse">
                        <i className="fab fa-facebook" aria-hidden="true"></i>
                        <span className="sr-only">Facebook</span>
                      </a>
                      <a href="https://instagram.com/hanthanahousekandy">
                        <i className="fab fa-instagram" aria-hidden="true"></i>
                        <span className="sr-only">Instagram</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 col-lg-7">
                <form
                  className="contact-one__form contact-form-validated form-one"
                  onSubmit={handleSubmit}
                >
                  <div className="contact-one__form__top">
                    <div className="sec-title text-start">
                      <h6 className="sec-title__tagline">Talk to Us</h6>
                      <h3 className="sec-title__title">
                        Any Doubts?
                        <br />
                        Feel Free to Contact
                      </h3>
                    </div>
                  </div>

                  {status && <p style={{ marginBottom: 15 }}>{status}</p>}

                  <div className="form-one__group">
                    <div className="form-one__control">
                      <input
                        type="text"
                        name="userName"
                        placeholder="Your name"
                        value={formData.userName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-one__control">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email address"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-one__control">
                      <input
                        type="text"
                        name="phoneNumber"
                        placeholder="Phone number"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="form-one__control form-one__control--full">
                      <textarea
                        name="notes"
                        placeholder="Your Inquiry"
                        value={formData.notes}
                        onChange={handleChange}
                        required
                      ></textarea>
                    </div>
                    <div className="form-one__control form-one__control--full">
                      <button type="submit" className="villoz-btn">
                        <i>Send a Message</i>
                        <span>Send a Message</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="contact-map">
          <div className="google-map google-map__contact">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3957.697975555124!2d80.62438707567526!3d7.275166892731925!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae368a3aae214bb%3A0xd808f9b5213565d5!2sHanthana%20House%20Kandy!5e0!3m2!1sen!2slk!4v1733943289434!5m2!1sen!2slk"
              className="map__contact"
              allowFullScreen
            ></iframe>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Contact;
